import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import DigitalAssessmentInfoModal from 'legacy/src/components/assessment/DigitalAssessmentInfoModal';
import { useDigitalAssessmentInfoModal } from 'legacy/src/components/assessment/DigitalAssessmentInfoModal/hooks';

const DigitalAssessmentInfoModalWrapper = ({ userData, subjectData }) => {
  const { isAdmin, isCoordinator } = userData;

  const { isPreApSubject } = subjectData;

  const {
    digitalAssessmentInfoModalOpen,
    setDigitalAssessmentInfoModalOpen,
    hideDigitalAssesmentUserPreferenceExists,
  } = useDigitalAssessmentInfoModal({
    userPreferences: userData.me.preferences,
  });

  const closeDigitalAssessmentInfoModal = () => {
    // save in session storage that user has seen the modal
    // next time user logs in, the modal will show if the preference for hiding it is not set
    window.sessionStorage.setItem('HIDE_DIGITAL_ASSESSMENT_INFO_MODAL', 'true');
    setDigitalAssessmentInfoModalOpen(false);
  };

  const userHasSeenModal = !!window.sessionStorage.getItem(
    'HIDE_DIGITAL_ASSESSMENT_INFO_MODAL',
  );

  return (
    <Fragment>
      {(isAdmin || isCoordinator) &&
        !isPreApSubject &&
        !hideDigitalAssesmentUserPreferenceExists &&
        !userHasSeenModal &&
        digitalAssessmentInfoModalOpen && (
          <DigitalAssessmentInfoModal
            onClose={closeDigitalAssessmentInfoModal}
            isAdminOrCoordinator
          />
        )}
    </Fragment>
  );
};

export default connect(
  ({
    userData,
    subject: { data: subjectData },
    visitedUnits,
    featureFlag,
  }) => ({
    userData,
    subjectData,
    visitedUnits,
    featureFlag,
  }),
)(DigitalAssessmentInfoModalWrapper);
